/* ============================================================
   ELOTUSS — Cart System (Shopify Ajax API Edition)
   Handles: Shopify Ajax cart, slide-in drawer,
            mobile full-screen nav, bag badge, add-to-cart,
            full-screen search (Predictive Search API),
            exit-intent newsletter popup
   ============================================================ */

(function () {
  'use strict';

  var NL_KEY      = 'elotuss_nl_v1';

  /* ─────────────────────────────────────────
     MONEY FORMATTER
  ───────────────────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ─────────────────────────────────────────
     SHOPIFY AJAX CART API
  ───────────────────────────────────────── */
  function getCart() {
    return fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function addItem(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity || 1,
        properties: properties || {}
      })
    }).then(function (r) { return r.json(); });
  }

  function changeItem(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function clearCart() {
    return fetch('/cart/clear.js', { method: 'POST' })
      .then(function (r) { return r.json(); });
  }

  /* ─────────────────────────────────────────
     BADGE
  ───────────────────────────────────────── */
  function updateBadge() {
    return getCart().then(function (cart) {
      var count = cart.item_count || 0;
      document.querySelectorAll('.e-cart-badge').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    });
  }

  /* ─────────────────────────────────────────
     DRAWER
  ───────────────────────────────────────── */
  var drawerOpen = false;

  function injectDrawer() {
    if (document.getElementById('e-drawer')) return;
    var el = document.createElement('div');
    el.innerHTML =
      '<div class="e-drawer-overlay" id="e-drawer-overlay"></div>' +
      '<aside class="e-drawer" id="e-drawer" aria-label="Shopping bag" role="dialog">' +
        '<div class="e-drawer__header">' +
          '<p class="e-drawer__title">Your Bag</p>' +
          '<button class="e-drawer__close" id="e-drawer-close" aria-label="Close bag">' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.3"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="e-drawer-items" id="e-drawer-items"></div>' +
        '<div class="e-drawer__footer" id="e-drawer-footer">' +
          '<div class="e-drawer__subtotal-row">' +
            '<span class="e-drawer__subtotal-label">Subtotal</span>' +
            '<span class="e-drawer__subtotal-value" id="e-drawer-subtotal">—</span>' +
          '</div>' +
          '<div class="e-drawer__shipping-note" id="e-drawer-shipping"></div>' +
          '<a href="/checkout" class="e-drawer__checkout-btn">Proceed to Checkout</a>' +
          '<a href="/cart" class="e-drawer__view-cart">View full cart</a>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(el);
    document.getElementById('e-drawer-overlay').addEventListener('click', closeDrawer);
    document.getElementById('e-drawer-close').addEventListener('click', closeDrawer);
  }

  function openDrawer() {
    var drawer  = document.getElementById('e-drawer');
    var overlay = document.getElementById('e-drawer-overlay');
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    drawerOpen = true;
    renderDrawerItems();
  }

  function closeDrawer() {
    var drawer  = document.getElementById('e-drawer');
    var overlay = document.getElementById('e-drawer-overlay');
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    drawerOpen = false;
  }

  function renderDrawerItems() {
    var container  = document.getElementById('e-drawer-items');
    var subtotalEl = document.getElementById('e-drawer-subtotal');
    var shippingEl = document.getElementById('e-drawer-shipping');
    if (!container) return;

    getCart().then(function (cart) {
      if (cart.item_count === 0) {
        container.innerHTML =
          '<div class="e-drawer-empty">' +
            '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1"><path d="M8 8l2.5 18h19L32 8"/><path d="M14 14a6 6 0 0012 0"/></svg>' +
            '<p class="e-drawer-empty__title">Your bag is empty.</p>' +
            '<p class="e-drawer-empty__sub">Add something beautiful.</p>' +
            '<a href="/collections/all" class="e-drawer-empty__btn">Shop Now</a>' +
          '</div>';
        if (subtotalEl) subtotalEl.textContent = '$0.00';
        if (shippingEl) shippingEl.innerHTML = '';
        return;
      }

      container.innerHTML = cart.items.map(function (item, idx) {
        var img = item.image
          ? '<img src="' + escHtml(item.image) + '" alt="' + escHtml(item.product_title) + '" width="70" height="85" loading="lazy">'
          : '<div class="e-drawer-item__img-placeholder"></div>';
        var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="e-drawer-item__variant">' + escHtml(item.variant_title) + '</p>' : '';
        return (
          '<div class="e-drawer-item" data-line="' + (idx + 1) + '">' +
            '<div class="e-drawer-item__img">' + img + '</div>' +
            '<div class="e-drawer-item__info">' +
              '<p class="e-drawer-item__name">' + escHtml(item.product_title) + '</p>' +
              variantLabel +
              '<p class="e-drawer-item__price">' + formatMoney(item.final_line_price) + '</p>' +
              '<div class="e-drawer-item__qty-row">' +
                '<button class="e-qty-btn" data-action="decrease" data-line="' + (idx + 1) + '" data-qty="' + item.quantity + '">−</button>' +
                '<span class="e-qty-val">' + item.quantity + '</span>' +
                '<button class="e-qty-btn" data-action="increase" data-line="' + (idx + 1) + '" data-qty="' + item.quantity + '">+</button>' +
              '</div>' +
            '</div>' +
            '<button class="e-drawer-item__remove" data-line="' + (idx + 1) + '" aria-label="Remove">✕</button>' +
          '</div>'
        );
      }).join('');

      container.querySelectorAll('.e-qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = parseInt(this.dataset.line);
          var qty  = parseInt(this.dataset.qty);
          var newQty = this.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
          this.disabled = true;
          changeItem(line, newQty).then(function () {
            return Promise.all([renderDrawerItems(), updateBadge()]);
          });
        });
      });

      container.querySelectorAll('.e-drawer-item__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          changeItem(parseInt(this.dataset.line), 0).then(function () {
            return Promise.all([renderDrawerItems(), updateBadge()]);
          });
        });
      });

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      if (shippingEl) {
        var threshold = 15000;
        if (cart.total_price >= threshold) {
          shippingEl.innerHTML = '<div class="e-drawer__free-ship e-drawer__free-ship--unlocked">🎉 Free shipping unlocked!</div>';
        } else {
          var remaining = threshold - cart.total_price;
          var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
          shippingEl.innerHTML =
            '<div class="e-drawer__free-ship"><p>Add ' + formatMoney(remaining) + ' for free shipping</p>' +
            '<div class="e-drawer__ship-bar"><div class="e-drawer__ship-fill" style="width:' + pct + '%"></div></div></div>';
        }
      }
    });
  }

  /* ─────────────────────────────────────────
     ADD TO CART HOOK
  ───────────────────────────────────────── */
  function hookAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      addItem(parseInt(variantInput.value))
        .then(function () { return Promise.all([updateBadge(), renderDrawerItems()]); })
        .then(function () {
          openDrawer();
          if (btn) {
            btn.textContent = 'Added ✓';
            setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 1600);
          }
        })
        .catch(function (err) {
          console.error('[Elotuss] Add to cart error:', err);
          if (btn) { btn.textContent = origText; btn.disabled = false; }
        });
    });
  }

  /* ─────────────────────────────────────────
     MOBILE MENU
  ───────────────────────────────────────── */
  function injectMobileMenu() {
    if (document.getElementById('e-mobile-menu')) return;
    var nav = document.querySelector('.e-nav');
    if (!nav) return;
    var links = nav.querySelectorAll('.e-nav__links a');
    var linksHTML = Array.from(links).map(function (a) {
      return '<a href="' + a.href + '" class="e-mobile-menu__link">' + a.textContent + '</a>';
    }).join('');
    var el = document.createElement('div');
    el.innerHTML =
      '<div class="e-mobile-menu" id="e-mobile-menu" role="dialog">' +
        '<div class="e-mobile-menu__header">' +
          '<span class="e-mobile-menu__logo">Elotuss</span>' +
          '<button class="e-mobile-menu__close" id="e-mobile-close" aria-label="Close menu">' +
            '<svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M4 4l14 14M18 4L4 18" stroke="currentColor" stroke-width="1.3"/></svg>' +
          '</button>' +
        '</div>' +
        '<nav class="e-mobile-menu__nav">' + linksHTML + '</nav>' +
        '<div class="e-mobile-menu__footer">' +
          '<a href="/account" class="e-mobile-menu__util">Account</a>' +
          '<a href="/pages/contact" class="e-mobile-menu__util">Contact</a>' +
        '</div>' +
      '</div>' +
      '<div class="e-mobile-overlay" id="e-mobile-overlay"></div>';
    document.body.appendChild(el);
    document.getElementById('e-mobile-close').addEventListener('click', closeMobileMenu);
    document.getElementById('e-mobile-overlay').addEventListener('click', closeMobileMenu);
  }

  function openMobileMenu() {
    var menu = document.getElementById('e-mobile-menu');
    var ov   = document.getElementById('e-mobile-overlay');
    if (!menu) return;
    menu.classList.add('open');
    ov.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    var menu = document.getElementById('e-mobile-menu');
    var ov   = document.getElementById('e-mobile-overlay');
    if (!menu) return;
    menu.classList.remove('open');
    ov.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ─────────────────────────────────────────
     NAV ENHANCEMENT
  ───────────────────────────────────────── */
  function enhanceNav() {
    var nav = document.querySelector('.e-nav');
    if (!nav) return;

    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });

    var hamburger = nav.querySelector('.e-nav__hamburger, [aria-label="Menu"]');
    if (hamburger) hamburger.addEventListener('click', openMobileMenu);

    nav.querySelectorAll('.e-nav__icon').forEach(function (icon) {
      var svg   = icon.querySelector('svg');
      if (!svg) return;
      var label = (icon.getAttribute('aria-label') || '').toLowerCase();

      if (label.includes('bag') || label.includes('cart') || (svg.innerHTML && svg.innerHTML.includes('6v14'))) {
        if (!icon.querySelector('.e-cart-badge')) {
          var badge = document.createElement('span');
          badge.className = 'e-cart-badge';
          badge.style.display = 'none';
          icon.appendChild(badge);
        }
        icon.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
      }

      if (label.includes('search')) {
        icon.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
      }
    });
  }

  /* ─────────────────────────────────────────
     SEARCH OVERLAY
  ───────────────────────────────────────── */
  function injectSearchOverlay() {
    if (document.getElementById('e-search-overlay')) return;
    var el = document.createElement('div');
    el.innerHTML =
      '<div class="e-search-overlay" id="e-search-overlay" role="dialog" aria-label="Search">' +
        '<div class="e-search-overlay__inner">' +
          '<div class="e-search-overlay__top">' +
            '<button class="e-search-overlay__close" id="e-search-close" aria-label="Close search">' +
              '<svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M4 4l14 14M18 4L4 18" stroke="currentColor" stroke-width="1.3"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="e-search-overlay__form-wrap">' +
            '<form class="e-search-overlay__form" action="/search" method="get">' +
              '<input type="hidden" name="type" value="product">' +
              '<input class="e-search-overlay__input" id="e-search-input" name="q" type="search" placeholder="Search for robes, wraps, styles…" autocomplete="off" spellcheck="false">' +
              '<button type="button" class="e-search-overlay__clear" id="e-search-clear" aria-label="Clear">✕</button>' +
            '</form>' +
          '</div>' +
          '<div class="e-search-suggestions" id="e-search-suggestions">' +
            '<p class="e-search-suggestions__label">Popular</p>' +
            '<div class="e-search-suggestions__pills">' +
              '<a href="/search?q=robe&type=product" class="e-search-suggestion-pill">Robe</a>' +
              '<a href="/search?q=wrap&type=product" class="e-search-suggestion-pill">Wrap</a>' +
              '<a href="/search?q=loungewear&type=product" class="e-search-suggestion-pill">Loungewear</a>' +
              '<a href="/collections/all" class="e-search-suggestion-pill">All Products</a>' +
            '</div>' +
          '</div>' +
          '<div id="e-search-results"></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);

    document.getElementById('e-search-close').addEventListener('click', closeSearch);
    document.getElementById('e-search-overlay').addEventListener('click', function (e) {
      if (e.target === this) closeSearch();
    });

    var input = document.getElementById('e-search-input');
    var clear = document.getElementById('e-search-clear');
    var timer;

    input.addEventListener('input', function () {
      var q = this.value.trim();
      clear.classList.toggle('visible', q.length > 0);
      clearTimeout(timer);
      if (q.length < 2) {
        document.getElementById('e-search-results').innerHTML = '';
        document.getElementById('e-search-suggestions').style.display = '';
        return;
      }
      document.getElementById('e-search-suggestions').style.display = 'none';
      timer = setTimeout(function () { renderSearchResults(q); }, 220);
    });

    clear.addEventListener('click', function () {
      input.value = '';
      clear.classList.remove('visible');
      document.getElementById('e-search-results').innerHTML = '';
      document.getElementById('e-search-suggestions').style.display = '';
      input.focus();
    });
  }

  function renderSearchResults(query) {
    var container = document.getElementById('e-search-results');
    if (!container) return;
    container.innerHTML = '<div class="e-search-loading">Searching…</div>';

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (products.length === 0) {
          container.innerHTML =
            '<div class="e-search-no-results"><p>No results for "<strong>' + escHtml(query) + '</strong>"</p>' +
            '<a href="/collections/all">Browse all products →</a></div>';
          return;
        }
        container.innerHTML =
          '<p class="e-search-results__heading">' + products.length + ' result' + (products.length !== 1 ? 's' : '') + ' for "' + escHtml(query) + '"</p>' +
          '<div class="e-search-results__grid">' +
          products.map(function (p) {
            var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : '';
            var price = p.price ? formatMoney(p.price) : '';
            return (
              '<a href="' + escHtml(p.url) + '" class="e-search-result-card">' +
                '<div class="e-search-result-card__img">' +
                  (img ? '<img src="' + escHtml(img) + '" alt="' + escHtml(p.title) + '" loading="lazy">' : '<div class="e-search-result-card__placeholder"></div>') +
                '</div>' +
                '<p class="e-search-result-card__name">' + escHtml(p.title) + '</p>' +
                (price ? '<p class="e-search-result-card__price">' + price + '</p>' : '') +
              '</a>'
            );
          }).join('') + '</div>';
      })
      .catch(function () {
        container.innerHTML = '<div class="e-search-no-results"><p>Search unavailable. <a href="/collections/all">Browse all →</a></p></div>';
      });
  }

  function openSearch() {
    var ov = document.getElementById('e-search-overlay');
    if (!ov) return;
    ov.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var inp = document.getElementById('e-search-input');
      if (inp) inp.focus();
    }, 200);
  }

  function closeSearch() {
    var ov = document.getElementById('e-search-overlay');
    if (!ov) return;
    ov.classList.remove('open');
    document.body.style.overflow = '';
    var inp = document.getElementById('e-search-input');
    if (inp) inp.value = '';
    var clr = document.getElementById('e-search-clear');
    if (clr) clr.classList.remove('visible');
    var res = document.getElementById('e-search-results');
    if (res) res.innerHTML = '';
    var sug = document.getElementById('e-search-suggestions');
    if (sug) sug.style.display = '';
  }

  /* ─────────────────────────────────────────
     NEWSLETTER POPUP
  ───────────────────────────────────────── */
  function injectNewsletterPopup() {
    try {
      var stored = JSON.parse(localStorage.getItem(NL_KEY)) || {};
      if (stored.subscribed) return;
      if (stored.dismissCount >= 3) return;
    } catch (e) {}

    var el = document.createElement('div');
    el.innerHTML =
      '<div class="e-nl-overlay" id="e-nl-overlay">' +
        '<div class="e-nl-modal" role="dialog" aria-label="Newsletter">' +
          '<button class="e-nl-modal__x" id="e-nl-x" aria-label="Close">✕</button>' +
          '<div class="e-nl-modal__image">' +
            '<img src="https://cdn.shopify.com/s/files/1/0960/1253/4073/files/email_optin_image.jpg?v=1784165835" alt="Elotuss" loading="lazy">' +
            '<div class="e-nl-modal__image-overlay"></div>' +
            '<div class="e-nl-modal__image-text">' +
              '<p class="e-nl-modal__image-eyebrow">Exclusive Offer</p>' +
              '<div class="e-nl-modal__image-number">15%</div>' +
              '<p class="e-nl-modal__image-percent">Off Your First Order</p>' +
            '</div>' +
          '</div>' +
          '<div class="e-nl-modal__content">' +
            '<div id="e-nl-form-wrap">' +
              '<p class="e-nl-modal__eyebrow">Join the Inner Circle</p>' +
              '<h2 class="e-nl-modal__title">Luxury arrives in your inbox.</h2>' +
              '<p class="e-nl-modal__sub">New arrivals, exclusive pieces, and 15% off your first order.</p>' +
              '<form class="e-nl-modal__form" id="e-nl-form">' +
                '<input class="e-nl-modal__input" id="e-nl-email" type="email" placeholder="Your email address" required>' +
                '<button type="submit" class="e-nl-modal__submit">Claim My 15% Off</button>' +
                '<button type="button" class="e-nl-modal__no-thanks" id="e-nl-no-thanks">No thanks</button>' +
              '</form>' +
            '</div>' +
            '<div class="e-nl-modal__success" id="e-nl-success">' +
              '<div class="e-nl-modal__success-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" width="24" height="24"><polyline points="20 6 9 17 4 12"/></svg></div>' +
              '<p class="e-nl-modal__success-title">Welcome to Elotuss.</p>' +
              '<p class="e-nl-modal__success-sub">Your 15% off code is on its way.</p>' +
              '<div class="e-nl-modal__success-code">ELOTUSS15</div>' +
              '<button class="e-nl-modal__close-success" id="e-nl-close-success">Continue Shopping</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);

    document.getElementById('e-nl-x').addEventListener('click', dismissNewsletter);
    document.getElementById('e-nl-no-thanks').addEventListener('click', dismissNewsletter);
    document.getElementById('e-nl-close-success').addEventListener('click', closeNewsletter);
    document.getElementById('e-nl-overlay').addEventListener('click', function (e) {
      if (e.target === this) dismissNewsletter();
    });
    document.getElementById('e-nl-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.getElementById('e-nl-email').value;
      var btn = this.querySelector('.e-nl-modal__submit');
      btn.disabled = true;
      btn.textContent = 'Subscribing...';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VVvagN', {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2023-12-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              list_id: 'XhkZWa',
              email: email
            }
          }
        })
      }).finally(function () {
        try { localStorage.setItem(NL_KEY, JSON.stringify({ subscribed: true })); } catch (ex) {}
        document.getElementById('e-nl-form-wrap').style.display = 'none';
        document.getElementById('e-nl-success').classList.add('show');
      });
    });

    scheduleNewsletter();
  }

  function scheduleNewsletter() {
    var triggered = false;
    var enterTime = Date.now();
    function show() {
      if (triggered) return;
      if (window.location.pathname === '/cart') return;
      triggered = true;
      openNewsletter();
    }
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 8 && Date.now() - enterTime > 3000) show();
    });
    setTimeout(show, 30000);
  }

  function openNewsletter() {
    var ov = document.getElementById('e-nl-overlay');
    if (ov) { ov.classList.add('open'); document.body.style.overflow = 'hidden'; }
  }

  function closeNewsletter() {
    var ov = document.getElementById('e-nl-overlay');
    if (ov) { ov.classList.remove('open'); document.body.style.overflow = ''; }
  }

  function dismissNewsletter() {
    closeNewsletter();
    try {
      var stored = JSON.parse(localStorage.getItem(NL_KEY)) || {};
      stored.dismissCount = (stored.dismissCount || 0) + 1;
      localStorage.setItem(NL_KEY, JSON.stringify(stored));
    } catch (e) {}
  }

  /* ─────────────────────────────────────────
     INJECT STYLES
  ───────────────────────────────────────── */
  function injectStyles() {
    var css = [
      /* Drawer overlay */
      '.e-drawer-overlay{position:fixed;inset:0;z-index:8000;background:rgba(13,12,11,.45);backdrop-filter:blur(4px);opacity:0;pointer-events:none;transition:opacity .45s cubic-bezier(.16,1,.3,1);}',
      '.e-drawer-overlay.open{opacity:1;pointer-events:all;}',
      /* Drawer panel */
      '.e-drawer{position:fixed;top:0;right:0;bottom:0;width:100%;max-width:420px;z-index:8001;background:var(--warm-white,#faf8f5);display:flex;flex-direction:column;transform:translateX(100%);transition:transform .5s cubic-bezier(.16,1,.3,1);overflow:hidden;}',
      '.e-drawer.open{transform:translateX(0);}',
      '.e-drawer__header{display:flex;align-items:center;justify-content:space-between;padding:1.6rem 2rem 1.2rem;border-bottom:1px solid rgba(138,121,104,.12);flex-shrink:0;}',
      '.e-drawer__title{font-family:var(--sans,"Jost",sans-serif);font-size:.65rem;font-weight:500;letter-spacing:.22em;text-transform:uppercase;color:var(--black,#0d0c0b);}',
      '.e-drawer__close{background:none;border:none;cursor:none;padding:.2rem;color:var(--taupe,#8a7968);transition:color .3s;}',
      '.e-drawer__close:hover{color:var(--black,#0d0c0b);}',
      '.e-drawer-items{flex:1;overflow-y:auto;padding:1rem 2rem;}',
      /* Empty state */
      '.e-drawer-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:4rem 1rem;color:var(--taupe,#8a7968);}',
      '.e-drawer-empty svg{margin-bottom:1.2rem;opacity:.35;}',
      '.e-drawer-empty__title{font-family:var(--serif,"Playfair Display",serif);font-size:1.3rem;font-weight:300;color:var(--black,#0d0c0b);margin-bottom:.4rem;}',
      '.e-drawer-empty__sub{font-family:var(--sans,"Jost",sans-serif);font-size:.7rem;margin-bottom:1.8rem;}',
      '.e-drawer-empty__btn{font-family:var(--sans,"Jost",sans-serif);font-size:.62rem;font-weight:500;letter-spacing:.18em;text-transform:uppercase;padding:.85rem 2rem;background:var(--black,#0d0c0b);color:var(--cream,#f5f0e8);border:1px solid var(--black,#0d0c0b);text-decoration:none;transition:background .3s;}',
      '.e-drawer-empty__btn:hover{background:var(--dark-taupe,#5c5144);}',
      /* Item */
      '.e-drawer-item{display:grid;grid-template-columns:70px 1fr 24px;gap:1rem;align-items:start;padding:1.2rem 0;border-bottom:1px solid rgba(138,121,104,.1);}',
      '.e-drawer-item__img img{width:70px;height:85px;object-fit:cover;display:block;}',
      '.e-drawer-item__img-placeholder{width:70px;height:85px;background:var(--cream,#f5f0e8);}',
      '.e-drawer-item__name{font-family:var(--serif,"Playfair Display",serif);font-size:.95rem;font-weight:400;color:var(--black,#0d0c0b);margin-bottom:.2rem;}',
      '.e-drawer-item__variant{font-family:var(--sans,"Jost",sans-serif);font-size:.65rem;color:var(--taupe,#8a7968);letter-spacing:.04em;margin-bottom:.3rem;}',
      '.e-drawer-item__price{font-family:var(--sans,"Jost",sans-serif);font-size:.75rem;color:var(--dark-taupe,#5c5144);margin-bottom:.6rem;}',
      '.e-drawer-item__qty-row{display:flex;align-items:center;gap:.5rem;}',
      '.e-qty-btn{width:26px;height:26px;border:1px solid rgba(138,121,104,.25);background:none;cursor:none;font-size:1rem;color:var(--black,#0d0c0b);display:flex;align-items:center;justify-content:center;transition:background .2s;}',
      '.e-qty-btn:hover{background:var(--cream,#f5f0e8);}',
      '.e-qty-val{font-family:var(--sans,"Jost",sans-serif);font-size:.75rem;min-width:18px;text-align:center;}',
      '.e-drawer-item__remove{background:none;border:none;cursor:none;color:var(--taupe,#8a7968);transition:color .2s;padding:.2rem;align-self:flex-start;margin-top:.1rem;font-size:.9rem;}',
      '.e-drawer-item__remove:hover{color:var(--black,#0d0c0b);}',
      /* Footer */
      '.e-drawer__footer{flex-shrink:0;padding:1.5rem 2rem 2rem;border-top:1px solid rgba(138,121,104,.12);background:var(--warm-white,#faf8f5);}',
      '.e-drawer__subtotal-row{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:1rem;}',
      '.e-drawer__subtotal-label{font-family:var(--sans,"Jost",sans-serif);font-size:.62rem;letter-spacing:.15em;text-transform:uppercase;color:var(--taupe,#8a7968);}',
      '.e-drawer__subtotal-value{font-family:var(--serif,"Playfair Display",serif);font-size:1.4rem;font-weight:300;color:var(--black,#0d0c0b);}',
      '.e-drawer__free-ship{font-family:var(--sans,"Jost",sans-serif);font-size:.65rem;color:var(--taupe,#8a7968);margin-bottom:.8rem;line-height:1.5;}',
      '.e-drawer__free-ship p{margin-bottom:.4rem;}',
      '.e-drawer__free-ship--unlocked{color:#2d7a50;font-weight:500;}',
      '.e-drawer__ship-bar{height:2px;background:rgba(138,121,104,.2);border-radius:2px;}',
      '.e-drawer__ship-fill{height:100%;background:var(--sand,#c8b89a);border-radius:2px;transition:width .6s cubic-bezier(.16,1,.3,1);}',
      '.e-drawer__checkout-btn{display:block;width:100%;text-align:center;font-family:var(--sans,"Jost",sans-serif);font-size:.65rem;font-weight:500;letter-spacing:.18em;text-transform:uppercase;padding:1rem;margin-bottom:.6rem;background:var(--black,#0d0c0b);color:var(--cream,#f5f0e8);border:1px solid var(--black,#0d0c0b);text-decoration:none;transition:background .3s;}',
      '.e-drawer__checkout-btn:hover{background:var(--dark-taupe,#5c5144);}',
      '.e-drawer__view-cart{display:block;text-align:center;font-family:var(--sans,"Jost",sans-serif);font-size:.6rem;letter-spacing:.15em;text-transform:uppercase;color:var(--taupe,#8a7968);text-decoration:none;transition:color .3s;}',
      '.e-drawer__view-cart:hover{color:var(--black,#0d0c0b);}',
      /* Mobile menu */
      '.e-mobile-overlay{position:fixed;inset:0;z-index:8500;background:rgba(13,12,11,.5);opacity:0;pointer-events:none;transition:opacity .4s;}',
      '.e-mobile-overlay.open{opacity:1;pointer-events:all;}',
      '.e-mobile-menu{position:fixed;top:0;left:0;bottom:0;width:85%;max-width:360px;z-index:8501;background:var(--black,#0d0c0b);display:flex;flex-direction:column;transform:translateX(-100%);transition:transform .45s cubic-bezier(.16,1,.3,1);padding:2rem 2.5rem 3rem;}',
      '.e-mobile-menu.open{transform:translateX(0);}',
      '.e-mobile-menu__header{display:flex;align-items:center;justify-content:space-between;margin-bottom:3rem;}',
      '.e-mobile-menu__logo{font-family:var(--serif,"Playfair Display",serif);font-size:1.3rem;font-weight:300;letter-spacing:.3em;text-transform:uppercase;color:var(--cream,#f5f0e8);}',
      '.e-mobile-menu__close{background:none;border:none;cursor:none;color:rgba(245,240,232,.4);transition:color .3s;}',
      '.e-mobile-menu__close:hover{color:var(--cream,#f5f0e8);}',
      '.e-mobile-menu__nav{display:flex;flex-direction:column;gap:.25rem;flex:1;}',
      '.e-mobile-menu__link{font-family:var(--serif,"Playfair Display",serif);font-size:clamp(1.5rem,5vw,2rem);font-weight:300;color:var(--cream,#f5f0e8);letter-spacing:.02em;padding:.5rem 0;border-bottom:1px solid rgba(245,240,232,.06);transition:color .3s,padding-left .3s;}',
      '.e-mobile-menu__link:hover{color:var(--sand,#c8b89a);padding-left:.5rem;}',
      '.e-mobile-menu__footer{display:flex;gap:1.5rem;margin-top:2rem;}',
      '.e-mobile-menu__util{font-family:var(--sans,"Jost",sans-serif);font-size:.62rem;letter-spacing:.15em;text-transform:uppercase;color:rgba(245,240,232,.35);transition:color .3s;}',
      '.e-mobile-menu__util:hover{color:var(--sand,#c8b89a);}',
      /* Search overlay */
      '.e-search-overlay{position:fixed;inset:0;z-index:10500;background:rgba(13,12,11,.92);backdrop-filter:blur(8px);display:flex;align-items:flex-start;justify-content:center;padding-top:10vh;opacity:0;pointer-events:none;transition:opacity .4s cubic-bezier(.16,1,.3,1);}',
      '.e-search-overlay.open{opacity:1;pointer-events:all;}',
      '.e-search-overlay__inner{width:100%;max-width:680px;padding:0 1.5rem;}',
      '.e-search-overlay__top{display:flex;justify-content:flex-end;margin-bottom:2.5rem;}',
      '.e-search-overlay__close{background:none;border:none;cursor:none;color:rgba(245,240,232,.4);transition:color .3s;}',
      '.e-search-overlay__close:hover{color:var(--cream,#f5f0e8);}',
      '.e-search-overlay__form{position:relative;display:flex;align-items:center;border-bottom:1px solid rgba(245,240,232,.25);}',
      '.e-search-overlay__input{flex:1;background:none;border:none;outline:none;font-family:var(--serif,"Playfair Display",serif);font-size:clamp(1.4rem,4vw,2.2rem);font-weight:300;color:var(--cream,#f5f0e8);padding:.5rem 0;letter-spacing:.01em;}',
      '.e-search-overlay__input::placeholder{color:rgba(245,240,232,.25);}',
      '.e-search-overlay__clear{background:none;border:none;cursor:none;color:rgba(245,240,232,.35);font-size:.9rem;padding:.3rem;display:none;transition:color .3s;}',
      '.e-search-overlay__clear.visible{display:block;}',
      '.e-search-overlay__clear:hover{color:var(--cream,#f5f0e8);}',
      '.e-search-suggestions{margin-top:2.5rem;}',
      '.e-search-suggestions__label{font-family:var(--sans,"Jost",sans-serif);font-size:.58rem;letter-spacing:.2em;text-transform:uppercase;color:rgba(245,240,232,.3);margin-bottom:.8rem;}',
      '.e-search-suggestions__pills{display:flex;flex-wrap:wrap;gap:.5rem;}',
      '.e-search-suggestion-pill{font-family:var(--sans,"Jost",sans-serif);font-size:.62rem;letter-spacing:.12em;text-transform:uppercase;color:rgba(245,240,232,.55);border:1px solid rgba(245,240,232,.15);padding:.45rem 1rem;transition:color .3s,border-color .3s;}',
      '.e-search-suggestion-pill:hover{color:var(--cream,#f5f0e8);border-color:rgba(245,240,232,.4);}',
      '.e-search-loading{font-family:var(--sans,"Jost",sans-serif);font-size:.7rem;color:rgba(245,240,232,.35);margin-top:2rem;text-align:center;}',
      '.e-search-results__heading{font-family:var(--sans,"Jost",sans-serif);font-size:.6rem;letter-spacing:.15em;text-transform:uppercase;color:rgba(245,240,232,.3);margin:2rem 0 1.2rem;}',
      '.e-search-results__grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1rem;}',
      '.e-search-result-card{text-decoration:none;display:block;}',
      '.e-search-result-card__img{aspect-ratio:3/4;overflow:hidden;background:rgba(245,240,232,.06);margin-bottom:.6rem;}',
      '.e-search-result-card__img img{width:100%;height:100%;object-fit:cover;transition:transform .5s cubic-bezier(.16,1,.3,1);}',
      '.e-search-result-card:hover .e-search-result-card__img img{transform:scale(1.04);}',
      '.e-search-result-card__placeholder{width:100%;height:100%;background:rgba(245,240,232,.06);}',
      '.e-search-result-card__name{font-family:var(--serif,"Playfair Display",serif);font-size:.9rem;font-weight:300;color:var(--cream,#f5f0e8);margin-bottom:.2rem;}',
      '.e-search-result-card__price{font-family:var(--sans,"Jost",sans-serif);font-size:.65rem;color:var(--sand,#c8b89a);}',
      '.e-search-no-results{font-family:var(--sans,"Jost",sans-serif);font-size:.75rem;color:rgba(245,240,232,.4);text-align:center;margin-top:2rem;line-height:1.8;}',
      '.e-search-no-results a{color:var(--sand,#c8b89a);}',
      /* Newsletter */
      '.e-nl-overlay{position:fixed;inset:0;z-index:11000;background:rgba(13,12,11,.6);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center;padding:1rem;opacity:0;pointer-events:none;transition:opacity .4s;}',
      '.e-nl-overlay.open{opacity:1;pointer-events:all;}',
      '.e-nl-modal{background:var(--warm-white,#faf8f5);width:100%;max-width:780px;display:grid;grid-template-columns:1fr 1fr;position:relative;overflow:hidden;transform:scale(.95) translateY(20px);transition:transform .4s cubic-bezier(.16,1,.3,1);}',
      '.e-nl-overlay.open .e-nl-modal{transform:scale(1) translateY(0);}',
      '.e-nl-modal__x{position:absolute;top:1rem;right:1rem;z-index:2;background:none;border:none;cursor:none;font-size:1.1rem;color:rgba(245,240,232,.6);transition:color .3s;padding:.3rem;}',
      '.e-nl-modal__x:hover{color:var(--cream,#f5f0e8);}',
      '.e-nl-modal__image{position:relative;min-height:380px;overflow:hidden;}',
      '.e-nl-modal__image img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;}',
      '.e-nl-modal__image-overlay{position:absolute;inset:0;background:linear-gradient(to bottom right,rgba(13,12,11,.6),rgba(13,12,11,.3));}',
      '.e-nl-modal__image-text{position:absolute;bottom:2.5rem;left:2rem;z-index:1;}',
      '.e-nl-modal__image-eyebrow{font-family:var(--sans,"Jost",sans-serif);font-size:.55rem;letter-spacing:.2em;text-transform:uppercase;color:var(--sand,#c8b89a);margin-bottom:.4rem;}',
      '.e-nl-modal__image-number{font-family:var(--serif,"Playfair Display",serif);font-size:4rem;font-weight:300;color:var(--cream,#f5f0e8);line-height:1;margin-bottom:.1rem;}',
      '.e-nl-modal__image-percent{font-family:var(--sans,"Jost",sans-serif);font-size:.7rem;color:rgba(245,240,232,.75);letter-spacing:.06em;}',
      '.e-nl-modal__content{padding:3rem 2.5rem;display:flex;flex-direction:column;justify-content:center;}',
      '.e-nl-modal__eyebrow{font-family:var(--sans,"Jost",sans-serif);font-size:.6rem;letter-spacing:.2em;text-transform:uppercase;color:var(--taupe,#8a7968);margin-bottom:.8rem;}',
      '.e-nl-modal__title{font-family:var(--serif,"Playfair Display",serif);font-size:1.7rem;font-weight:300;color:var(--black,#0d0c0b);margin-bottom:.8rem;letter-spacing:-.01em;line-height:1.15;}',
      '.e-nl-modal__sub{font-family:var(--sans,"Jost",sans-serif);font-size:.72rem;color:var(--taupe,#8a7968);line-height:1.75;margin-bottom:1.5rem;}',
      '.e-nl-modal__input{width:100%;padding:.85rem 1rem;font-family:var(--sans,"Jost",sans-serif);font-size:.8rem;font-weight:300;background:var(--cream,#f5f0e8);border:1px solid transparent;outline:none;margin-bottom:.7rem;box-sizing:border-box;transition:border-color .2s;}',
      '.e-nl-modal__input:focus{border-color:var(--dark-taupe,#5c5144);}',
      '.e-nl-modal__input::placeholder{color:rgba(138,121,104,.6);}',
      '.e-nl-modal__submit{width:100%;padding:1rem;font-family:var(--sans,"Jost",sans-serif);font-size:.65rem;font-weight:500;letter-spacing:.18em;text-transform:uppercase;background:var(--black,#0d0c0b);color:var(--cream,#f5f0e8);border:1px solid var(--black,#0d0c0b);cursor:none;transition:background .3s;margin-bottom:.6rem;}',
      '.e-nl-modal__submit:hover{background:var(--dark-taupe,#5c5144);}',
      '.e-nl-modal__no-thanks{display:block;width:100%;text-align:center;font-family:var(--sans,"Jost",sans-serif);font-size:.6rem;letter-spacing:.12em;text-transform:uppercase;color:var(--taupe,#8a7968);background:none;border:none;cursor:none;transition:color .3s;padding:.4rem;}',
      '.e-nl-modal__no-thanks:hover{color:var(--black,#0d0c0b);}',
      '.e-nl-modal__success{display:none;text-align:center;}',
      '.e-nl-modal__success.show{display:block;}',
      '.e-nl-modal__success-icon{width:52px;height:52px;border:1px solid var(--sand,#c8b89a);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 1.2rem;}',
      '.e-nl-modal__success-title{font-family:var(--serif,"Playfair Display",serif);font-size:1.5rem;font-weight:300;color:var(--black,#0d0c0b);margin-bottom:.5rem;}',
      '.e-nl-modal__success-sub{font-family:var(--sans,"Jost",sans-serif);font-size:.7rem;color:var(--taupe,#8a7968);margin-bottom:.8rem;}',
      '.e-nl-modal__success-code{font-family:var(--sans,"Jost",sans-serif);font-size:.8rem;font-weight:500;letter-spacing:.25em;text-transform:uppercase;padding:.6rem 1.5rem;border:1px dashed var(--sand,#c8b89a);display:inline-block;margin-bottom:1.5rem;color:var(--dark-taupe,#5c5144);}',
      '.e-nl-modal__close-success{font-family:var(--sans,"Jost",sans-serif);font-size:.65rem;letter-spacing:.15em;text-transform:uppercase;padding:.8rem 2rem;background:var(--black,#0d0c0b);color:var(--cream,#f5f0e8);border:1px solid var(--black,#0d0c0b);cursor:none;transition:background .3s;}',
      '.e-nl-modal__close-success:hover{background:var(--dark-taupe,#5c5144);}',
      /* Responsive */
      '@media(max-width:600px){.e-nl-modal{grid-template-columns:1fr;}.e-nl-modal__image{min-height:180px;}.e-nl-modal__content{padding:2rem 1.5rem;}.e-search-results__grid{grid-template-columns:repeat(2,1fr);}}'
    ].join('\n');

    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ─────────────────────────────────────────
     ESC KEY HANDLER
  ───────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawerOpen) { closeDrawer(); return; }
    var mobileMenu = document.getElementById('e-mobile-menu');
    if (mobileMenu && mobileMenu.classList.contains('open')) { closeMobileMenu(); return; }
    var search = document.getElementById('e-search-overlay');
    if (search && search.classList.contains('open')) { closeSearch(); return; }
    var nl = document.getElementById('e-nl-overlay');
    if (nl && nl.classList.contains('open')) { dismissNewsletter(); return; }
  });

  /* ─────────────────────────────────────────
     PUBLIC API
  ───────────────────────────────────────── */
  window.ElotussCart = {
    open:        openDrawer,
    close:       closeDrawer,
    add:         addItem,
    change:      changeItem,
    clear:       clearCart,
    get:         getCart,
    updateBadge: updateBadge,
    refresh:     renderDrawerItems
  };

  window.ElotussSearch     = { open: openSearch,     close: closeSearch };
  window.ElotussNewsletter = { open: openNewsletter, close: closeNewsletter };

  /* ─────────────────────────────────────────
     INIT
  ───────────────────────────────────────── */
  function init() {
    injectStyles();
    injectDrawer();
    injectMobileMenu();
    injectSearchOverlay();
    injectNewsletterPopup();
    enhanceNav();
    hookAddToCart();
    updateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
